export default __webpack_public_path__ + "static/media/basket.e8c1b677.png";